import styles from "./Line.module.scss";

export const Line = () => {
  return <hr className={styles.line} />;
};
